import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import constants from '../utils/constants.json';

function PriceRange({ onRequest }) {
	const min = constants.MIN_PRICE;
	const max = constants.MAX_PRICE;

	const webSettings = useSelector(state => state.webSettings.data);

	const [minPrice, setMinPrice] = useState(min);
	const [maxPrice, setMaxPrice] = useState(max);

	const [minVal, setMinVal] = useState(min);
	const [maxVal, setMaxVal] = useState(max);

	const [rangeProps, setRangeProps] = useState({ left: 0, width: '100%' });

	const slider = useRef(null);

	useEffect(() => {
		if (maxVal > minVal) {
			setMinPrice(minVal);
			setMaxPrice(maxVal);
		} else {
			setMinPrice(maxVal);
			setMaxPrice(minVal);
		}
	}, [slider, minVal, maxVal]);

	useEffect(() => {
		let left = (minPrice / max) * 100;
		let width = ((maxPrice - minPrice) / max) * 100;
		setRangeProps({ left: left + '%', width: width + '%' });
	}, [minPrice, maxPrice]);

	function minBtnAction(val) {
		if (val < maxPrice) {
			if (minVal < maxVal) {
				setMinVal(val);
			} else {
				setMaxVal(val);
			}
		}
		//setMinVal(val);
	}

	function maxBtnAction(val) {
		if (val > minPrice) {
			if (maxVal > minVal) {
				setMaxVal(val);
			} else {
				setMinVal(val);
			}
		}
	}

	return (
		<div className='price-range listing'>
			<section className='m-header'>
				<p>Price ({webSettings.CURRENCY})</p>
				<button
					className='btn'
					onClick={() => {
						if (typeof onRequest === 'function') {
							onRequest(minPrice, maxPrice);
						}
					}}>
					Find
				</button>
			</section>
			<div ref={slider} className='price-slider'>
				<div className='range' style={rangeProps}></div>
				<input onChange={e => setMinVal(parseInt(e.target.value))} type='range' min={min} max={max} step='1' value={minVal} />
				<input onChange={e => setMaxVal(parseInt(e.target.value))} type='range' min={min} max={max} step='1' value={maxVal} />
			</div>
			<div className='values'>
				<input onInput={e => minBtnAction(parseInt(e.target.value))} type='number' value={minPrice} min={min} max={max} step='1' /> &nbsp;-&nbsp;
				<input onInput={e => maxBtnAction(parseInt(e.target.value))} type='number' value={maxPrice} min={min} max={max} step='1' />
			</div>
		</div>
	);
}

export default React.memo(PriceRange);
